<template>
    <header style="background-color: #296080;" class="navbar-light fixed-top header-static bg-mode">

        <!-- Logo Nav START -->
        <nav class="navbar navbar-expand-lg">
            <div class="container">

                <!-- Nav right START -->
                <ul class="nav flex-nowrap align-items-center ms-sm-3 list-unstyled">
                    <li class="nav-item nav-item-search ms-1">
                        <router-link class="nav-link icon-md btn p-0" to="/search">
                            <i class="bi bi-search fs-2" style="color: #ffffff;"></i>
                        </router-link>
                    </li>
                    <li class="nav-item dropdown ms-1">
                        <router-link class="nav-link icon-md btn p-0" to="/notifications" role="button">
                            <span class="badge-notif animation-blink"></span>
                            <i class="bi bi-bell fs-2" style="color: #ffffff;"></i>
                        </router-link>
                        <div class="dropdown-menu dropdown-animation dropdown-menu-end dropdown-menu-size-md p-0 shadow-lg border-0"
                            aria-labelledby="notifDropdown">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <h6 class="m-0">الاشعارات <span
                                            class="badge bg-danger bg-opacity-10 text-danger ms-2">4
                                            جديد</span></h6>
                                    <a class="small" href="#">مسح الكل</a>
                                </div>
                                <div class="card-body p-0">
                                    <ul class="list-group list-group-flush list-unstyled p-2">
                                        <li>
                                            <div
                                                class="list-group-item list-group-item-action rounded badge-unread d-flex border-0 mb-1 p-3">
                                                <div class="avatar text-center d-none d-sm-inline-block">
                                                    <img class="avatar-img rounded-circle"
                                                        src="assets/images/avatar/01.jpg" alt="">
                                                </div>
                                                <div class="ms-sm-3">
                                                    <div
                                                        class=" d-flex d-flex align-items-center justify-content-between">
                                                        <p class="small mb-2">تم ارسال طلب</p>
                                                        <p class="small mb-2 text-nowrap">الآن</p>
                                                    </div>
                                                    <div class="d-flex">
                                                        <button class="btn btn-sm py-1 btn-primary me-2">عرض
                                                        </button>
                                                        <button class="btn btn-sm py-1 btn-danger-soft">ازالة
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-footer text-center">
                                    <a href="#" class="btn btn-sm btn-primary-soft">عرض كل الاشعارات</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item ms-1">
                        <router-link class="nav-link icon-md btn p-0" to="/chats">
                            <i class="fas fa-paper-plane fs-2" style="color: #ffffff;"></i>
                        </router-link>
                    </li>
                    <li class="nav-item dropdown">
                        <!-- Responsive navbar toggler -->
                        <button class="navbar-toggler icon-md btn p-0" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span class="navbar-toggler-animation">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </li>
                    <!-- Notification dropdown END -->
                </ul>
                <!-- Nav right END -->

                <!-- Main navbar START -->
                <div class="collapse navbar-collapse" id="navbarCollapse">
                    <!-- Nav Search START -->
                    <div class="nav mt-3 mt-lg-0 flex-nowrap align-items-center px-4 px-lg-0">
                        <div class="nav-item w-100">
                            <form class="rounded position-relative">
                                <router-link to="/search">
                                    <input class="form-control ps-5 bg-light" type="search" placeholder="Search..."
                                        aria-label="Search">
                                </router-link>
                                <router-link to="/search"
                                    class="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y"
                                    type="submit"><i class="bi bi-search fs-5"> </i></router-link>
                            </form>
                        </div>
                    </div>
                    <!-- Nav Search END -->
                    <ul class="navbar-nav navbar-nav-scroll ms-auto">
                        <li class="nav-item dropdown show-sm-only">
                            <a class="nav-link btn icon-md p-0" href="#" id="profileDropdown" role="button"
                                data-bs-auto-close="outside" data-bs-display="static" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <img v-if="userData.users_image" class="avatar-img rounded border border-white border-3"
                                    :src="userData.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${userData.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                                    alt="صورة المستخدم" />
                                <img v-else class="avatar-img rounded border border-white border-3"
                                    src="assets/person.png" alt="صورة افتراضية" />
                            </a>
                            <ul class="dropdown-menu dropdown-animation dropdown-menu-end pt-3 small me-md-n3"
                                aria-labelledby="profileDropdown">
                                <!-- Profile info -->
                                <li class="px-3">
                                    <div class="d-flex align-items-center position-relative">
                                        <!-- Avatar -->
                                        <div class="avatar">
                                            <img v-if="userData.users_image"
                                                class="avatar-img rounded border border-white border-3"
                                                :src="userData.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${userData.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                                                alt="صورة المستخدم" />
                                            <img v-else class="avatar-img rounded border border-white border-3"
                                                src="assets/person.png" alt="صورة افتراضية" />
                                        </div>
                                        <div>
                                            {{ userData.users_name || 'اسم غير متوفر' }}
                                            <p class="small m-0">{{ userData.users_current_country }}</p>
                                        </div>
                                    </div>
                                    <router-link to="/profile"
                                        class="dropdown-item btn btn-primary-soft btn-sm my-2 text-center">
                                        الملف الشخصي
                                    </router-link>
                                </li>
                                <li><a @click="openModal" class="dropdown-item bg-danger-soft-hover">
                                        تسجيل الخروج<i class="bi bi-power fa-fw me-2"></i></a></li>
                            </ul>
                        </li>

                        <!-- Nav item 1 Demos -->
                        <li class="nav-item navBtn dropdown">
                            <!-- <a class="nav-link btn-navbar" href="/home">الصفحة الرئيسية</a> -->
                            <router-link to="/home" class="nav-link btn-navbar">
                                الصفحة الرئيسية
                            </router-link>
                        </li>

                        <!-- Nav item 3 Post -->
                        <li class="nav-item navBtn btn-navbar dropdown">
                            <!-- <a class="nav-link" href="/professions">المهن</a> -->
                            <router-link to="/professions" class="nav-link btn-navbar">
                                الفئات
                            </router-link>
                        </li>

                        <!-- Nav item 2 Pages -->
                        <li class="nav-item navBtn btn-navbar dropdown">
                            <!-- <a class="nav-link" href="/independents">المستقلين</a> -->
                            <router-link to="/independents" class="nav-link btn-navbar">
                                المتقنين
                            </router-link>
                        </li>

                        <!-- Nav item 2 Pages -->
                        <li class="nav-item navBtn btn-navbar dropdown">
                            <!-- <a class="nav-link" href="/independents">المستقلين</a> -->
                            <router-link to="/my-saves" class="nav-link btn-navbar">
                                محفوظاتي
                            </router-link>
                        </li>
                        <!-- Nav item 2 Pages -->
                        <li class="nav-item navBtn btn-navbar dropdown">
                            <!-- <a class="nav-link" href="/independents">المستقلين</a> -->
                            <a class="nav-link btn-navbar" href="https://zadcodeonline.com/ahmad/etqan/itqan_app.apk" target="_blank"> <i class="bi bi-phone fa-fw pe-2"></i> حمل
                                تطبيقنا</a>
                        </li>

                    </ul>
                </div>

                <!-- <button class="navbar-toggler ms-auto icon-md btn p-0" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-animation">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button> -->
                <span class="mb-0 ms-auto text-itkan mr-4 fw-bold d-lg-none">{{ pageTitle }}</span>
                <a class="navbar-brand" href="/home">
                    <img class="light-mode-item navbar-brand-item" src="../../assets/logo3.png" alt="logo">
                </a>




                <!-- Responsive navbar toggler -->
                <!-- <button class="navbar-toggler ms-auto icon-md btn btn-light p-0" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-animation">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button> -->
                <!-- Main navbar END -->



                <div v-if="isModalVisible" class="modal-overlay">
                    <div class="modal-content">
                        <h3>هل أنت متأكد أنك تريد تسجيل الخروج؟</h3>
                        <div class="modal-actions">
                            <button @click="logout" class="btn btn-confirm">نعم</button>
                            <button @click="closeModal" class="btn btn-cancel">لا</button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <!-- Logo Nav END -->
    </header>
</template>


<script>
import axios from 'axios';

export default {
    name: "HeaderComponent",
    props: {
        pageTitle: {
            type: String,
            default: "إتقان"
        }
    },
    data() {
        return {
            userData: {},
            loading: true,
            isModalVisible: false,
        };
    },
    mounted() {
        const userId = localStorage.getItem("userId");
        if (userId) {
            this.fetchUserData(userId);
        } else {
            console.error("User ID غير موجود في Local Storage.");
        }
    },
    methods: {
        async fetchUserData(userId) {
            try {
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view.php',
                    { usersid: userId },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                if (response.data.status === "success") {
                    this.userData = response.data.data;
                    this.loading = false;
                } else {
                    console.error("فشل في جلب بيانات المستخدم:", response.data);
                }
            } catch (error) {
                console.error("خطأ أثناء جلب بيانات المستخدم:", error);
            }
        },

        openModal() {
            this.isModalVisible = true;
        },

        closeModal() {
            this.isModalVisible = false;
        },

        logout() {
            localStorage.removeItem("isAuthenticated");

            this.$router.push("/login");

            this.closeModal();
        },
    },
};
</script>


<style scoped>
header {
    background-color: #296080;
    box-shadow: 0 4px 8px rgba(255, 72, 0, 0.4);
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
}

.navBtn .nav-link.btn-navbar {
    color: #ffffff;
    background-color: transparent;
    transition: all 0.3s ease-in-out;
}

.navBtn .nav-link.btn-navbar:hover {
    color: #64b6e6;
}



.badge-notif {
    width: 8px;
    height: 8px;
    background: #d6293e;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    right: 10px;
    z-index: 1;
}

li {
    margin: 0 0px !important;
}

.nav.flex-nowrap .nav-item {
    margin-left: 0.001rem !important;
}

.nav .nav-item {
    margin-left: 0.001rem !important;
}

.nav.flex-nowrap {
    gap: 0.001rem !important;
}

.navbar-toggler-animation span {
    background: white !important;
}

.navbar-toggler .navbar-toggler-animation {
    height: 24px;
    width: 25px;
}

.navbar-toggler {
    color: white;
    background-color: #296080;
    margin: 0 !important;
}

.navbar-brand {
    margin-right: 0rem;
}

.navbar-nav {
    align-items: flex-start;

}

.show-sm-only {
    display: none;
}

@media (min-width: 991px) {
    .nav-item-search {
        display: none;
    }
}

@media (max-width: 991px) {
    .navBtn .nav-link.btn-navbar {
        color: #296080 !important;
    }

    .show-sm-only {
        display: block;
    }
}


/* مودال التأكيد */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    max-width: 400px;
    width: 100%;
}

.modal-actions {
    margin-top: 20px;
}

button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 10px;
}

.btn-confirm {
    background-color: #296080;
    color: white;
}

.btn-cancel {
    background-color: #ccc;
}



a {
    color: #296080;
}

.navbar-light .navbar-nav .nav-link {
    color: #ffffff;
}


footer {
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #f8f9fa;
    padding: 20px;
    text-align: center;
}

.card-header {
    border-radius: 30px;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #296080;
}

.text-itkan {
    display: block !important;
    font-size: 15px;
    color: #ffffff;
}


.text-person {
    color: #296080;
}

.text-date {
    font-size: 10px;
    color: #2e2e2e;
}

.rounded-card {
    border-radius: 25px;
    overflow: hidden;
}

.carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
}

@media (max-width: 992px) {
    .carousel-item img {
        border-radius: 30px;
        height: 200px;
        object-fit: cover;
    }

    .text-itkan {
        font-size: 15px;
        color: #ffffff;
    }
}



@media (max-width: 992px) {
    .navbar-light .navbar-nav .nav-link[data-v-b8058e74] {
        color: #296080;
    }

    .navbar>.container,
    .navbar>.container-fluid,
    .navbar>.container-sm,
    .navbar>.container-md,
    .navbar>.container-lg,
    .navbar>.container-xl,
    .navbar>.container-xxl {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: inherit;
        flex-wrap: inherit;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}
</style>